import {
  createPartnersPortalRpcClient,
  type PartnersPortalRpcClient,
} from "@redotech/redo-partners-portal-rpc/client";
import {
  type Context,
  createContext,
  type ReactNode,
  useContext,
  useMemo,
} from "react";

import { REDO_PARTNERS_PORTAL_SERVER_URL } from "../config";

const PartnersPortalRpcClientContext: Context<
  PartnersPortalRpcClient | undefined
> = createContext<PartnersPortalRpcClient | undefined>(undefined);

export function PartnersPortalRpcClientProvider({
  children,
  authToken,
}: {
  children: ReactNode;
  authToken: string | undefined;
}) {
  // Headers are fixed when the client is built, so rebuild it per token.
  const client = useMemo(
    () =>
      createPartnersPortalRpcClient({
        baseURL: new URL(`${REDO_PARTNERS_PORTAL_SERVER_URL}/rpc`),
        headers: authToken ? { Authorization: `Bearer ${authToken}` } : {},
      }),
    [authToken],
  );
  return (
    <PartnersPortalRpcClientContext.Provider value={client}>
      {children}
    </PartnersPortalRpcClientContext.Provider>
  );
}

export function usePartnersPortalRpcClient(): PartnersPortalRpcClient {
  const client = useContext(PartnersPortalRpcClientContext);
  if (!client) {
    throw new Error(
      "usePartnersPortalRpcClient must be used within PartnersPortalRpcClientProvider",
    );
  }
  return client;
}
